import React from "react";

const IconCheckbox = () => {
  return (
    <svg width="20px" height="20px">
      <polyline
        points="1.5 6 4.5 9 10.5 1"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};

export default IconCheckbox;
